import { useFormContext, useWatch } from 'react-hook-form'
import { ItemRegraTransformacaoAcaoForm } from '../../../types/transformacaoApiTypes'
import { stylesFieldForms } from '../styles'

export function fieldsBuscarLinhaTransformacaoApiIO() {
  const { control } = useFormContext()

  const acaoSelecionada: ItemRegraTransformacaoAcaoForm[] = useWatch({
    name: 'acoes',
    control
  })

  return {
    styles: stylesFieldForms,
    control,
    acaoSelecionada
  }
}

export type FieldsBuscarLinhaTransformacaoApiIO = ReturnType<typeof fieldsBuscarLinhaTransformacaoApiIO>
